import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { AngularFirestore } from '@angular/fire/firestore';
import { Subscription } from 'rxjs';

export interface MovieInformations {
  id: string;
  productionYear: number;
  title: string;
  director: string;
  genre: string;
  productionCompany: string
}

@Component({
  selector: 'tonteppich-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss']
})
export class ReferencesComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['productionYear', 'title', 'director', 'genre', 'productionCompany'];

  dataSource;

  private sub: Subscription;

  constructor(private db: AngularFirestore) { }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    this.sub = this.db.collection<MovieInformations>('movies').valueChanges().subscribe(data => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort;
    })
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }
}
